import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import Banner from '@adsk/alloy-react-banner';
import { ModalConfirmation } from '@adsk/alloy-react-modal';
import { useLocale } from '@adsk/alloy-react-locale';
import Header from './Header';
import GeneralDetails from './GeneralDetails';
import AdvancedDetails from './AdvancedDetails';
import { adminAccessProductsPropTypes } from '../propTypes';
import { progressRingWrapperDivStyle, progressRingStyle } from '../styles';

const CategorizedContent = ({
  account,
  adminAccessProducts,
  disableCreateTemplateButton,
  isEditing,
  isAdminUser,
  isEmsAccount,
  loading,
  onCancelButtonClick,
  onEditButtonClick,
  onModalConfirmationCancel,
  onModalConfirmationConfirm,
  onSaveButtonClick,
  onSaveAsTemplateClose,
  onSaveAsTemplateSuccess,
  onSaveAsTemplateButtonClick,
  project,
  showInformationBanner,
  showInProductSettings,
  showModalConfirmation,
  showCreateTemplateButton,
  showCreateTemplateModal,
}) => {
  const [bannerOpen, setBannerOpen] = useState(showInformationBanner);
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  if (loading) {
    return (
      // TODO: Implement generic/shared progress ring page block component
      <div css={progressRingWrapperDivStyle}>
        <ProgressRing
          style={progressRingStyle}
          size={ProgressRing.SIZES.MEDIUM}
        />
      </div>
    );
  }

  return (
    <>
      <Header
        account={account}
        adminAccessProducts={adminAccessProducts}
        disableCreateTemplateButton={disableCreateTemplateButton}
        isEmsAccount={isEmsAccount}
        onCancelButtonClick={onCancelButtonClick}
        onEditButtonClick={onEditButtonClick}
        onSaveButtonClick={onSaveButtonClick}
        onSaveAsTemplateClose={onSaveAsTemplateClose}
        onSaveAsTemplateSuccess={onSaveAsTemplateSuccess}
        onSaveAsTemplateButtonClick={onSaveAsTemplateButtonClick}
        project={project}
        showEditButton={isAdminUser}
        showInProductSettings={showInProductSettings}
        showCreateTemplateButton={showCreateTemplateButton}
        showCreateTemplateModal={showCreateTemplateModal}
      />
      {isEditing && bannerOpen && (
        <Banner
          inline
          message={T.translate('EDIT_PROJECT_BANNER_INFORMATION')}
          onClose={() => setBannerOpen(false)}
          style={{ p: { margin: 'revert' } }} // necessary to counteract the effects of the css reset set on acs-admin-client
        />
      )}
      <GeneralDetails isEmsAccount={isEmsAccount} />
      {isAdminUser && <AdvancedDetails isEmsAccount={isEmsAccount} />}
      <ModalConfirmation
        show={showModalConfirmation}
        title={T.translate('EDIT_PROJECT_FORM_CANCEL_CONFIRMATION_TITLE')}
        message={T.translate('EDIT_PROJECT_FORM_CANCEL_CONFIRMATION_MESSAGE')}
        cancelButtonLabel={T.translate(
          'EDIT_PROJECT_FORM_CANCEL_CONFIRMATION_BACK_BUTTON'
        )}
        confirmationButtonLabel={T.translate(
          'EDIT_PROJECT_FORM_CANCEL_CONFIRMATION_CANCEL_BUTTON'
        )}
        onConfirm={onModalConfirmationConfirm}
        onClose={onModalConfirmationCancel}
        disableModalExit
        isConfirmationButtonDisabled={false}
        isOnConfirmInProgress={false}
        hideOnConfirm={false}
        noCancelButton={false}
      />
    </>
  );
};

CategorizedContent.propTypes = {
  account: PropTypes.object,
  adminAccessProducts: adminAccessProductsPropTypes,
  disableCreateTemplateButton: PropTypes.bool,
  isAdminUser: PropTypes.bool,
  isEditing: PropTypes.bool,
  isEmsAccount: PropTypes.bool,
  loading: PropTypes.bool,
  onCancelButtonClick: PropTypes.func,
  onEditButtonClick: PropTypes.func,
  onModalConfirmationCancel: PropTypes.func,
  onModalConfirmationConfirm: PropTypes.func,
  onSaveAsTemplateButtonClick: PropTypes.func,
  onSaveAsTemplateClose: PropTypes.func,
  onSaveAsTemplateSuccess: PropTypes.func,
  onSaveButtonClick: PropTypes.func,
  project: PropTypes.object,
  showCreateTemplateButton: PropTypes.bool,
  showCreateTemplateModal: PropTypes.bool,
  showInformationBanner: PropTypes.bool,
  showInProductSettings: PropTypes.bool,
  showModalConfirmation: PropTypes.bool,
};

CategorizedContent.defaultProps = {
  isEmsAccount: false,
};

export default CategorizedContent;
